import React, { useEffect, useState } from 'react';
import { TextField,  Container, Typography, Box, Grid } from '@mui/material';
import CustomButton from '../../components/CustomButton';
import { useTheme } from '@emotion/react';
import { tokens } from '../../theme';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { ApiType } from '../../services/ApiTags';
import { getFromLocalStorage, saveToLocalStorage } from '../../utils/localStorageUtils';
import { MESSAGE_KEY, SESSION_ID } from '../../constants/LocalStorageKeyValuePairString';
import useAxiosHook from '../../hooks/UseAxios';
import { ALERT, ERROR, ERROR_WHILE_FETCHING_DATA, NO_INTERNET_CONNECTION_FOUND, PROCESSING_PLEASE_WAIT, YOU_ARE_OFFLINE, YOU_ARE_ONLINE, SUCCESS } from '../../constants/Strings';
import UseOnlineStatus from '../../utils/UseOnlineStatus';
import DebugLog from '../../utils/DebugLog';
import { Navigate, useNavigate } from 'react-router-dom';
import { initializeEncryption } from '../../services/AesGcmEncryption';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { showErrorAlertDialog, showSuccessAlertDialog } from '../../config/AppConfig';
import { useAtom } from 'jotai';
import ShowErrorAlertDialog from '../../components/ErrorAlertDialog';
import ConnectionStatus from '../../utils/ConnectionStatus';
import CustomProgressDialog from '../../components/CustomProgressDialog';
import * as CONSTANT from "../../constants/Constant";
import ShowSuccessDialog from '../../components/ShowSuccessDialog';

const ChangePassword = () => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const [loading, setLoading] = useState(false);
  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [getProgressbarText, setProgressbarText] = useState("");

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [getSuccessDialogStatus, setSuccessDialog] = useAtom(showSuccessAlertDialog);

  // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
  //const passwordWithUpperCaseRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
 // const passwordWithoutUpperCaseRegex = /^(?=.*[a-z])(?=.*)(?=.*\d)(?=.*[@$!%*?&])[a-z\d@$!%*?&]{8,}$/;
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@&])[A-Za-z\d@&]{8,20}$/;

  const { data, error, showProgressBar, fetchData } = useAxiosHook();

  useEffect(() => {
  }, [isNetworkConnectionAvailable, enqueueSnackbar, Navigate]);

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };


  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
       setLoading(false);
    }
  }, [showProgressBar]);



  useEffect(() => {
    if (error) {
      if (
        error.data != null &&
        error.data.responseCode != null &&
        error.data.responseCode != -1
      ) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      } else {
        const message =
          error.data != null ? error.data.displayErrorMessage : error.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA+ JSON.stringify(message)
        );
      
      }
    }
  }, [error]);

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }


  function showSuccessAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setSuccessDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }


  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleCurrentPasswordVisibility = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if(formData.currentPassword===undefined){
      newErrors.currentPassword = "Please enter your current password!";
      }
    else if(formData.currentPassword===null || formData.currentPassword===""){
        newErrors.currentPassword = "Please enter your current password!";
    }
    else if(formData.newPassword===""){
      newErrors.newPassword = "Please enter your new password!";
      }
     
    else if (formData.newPassword.length < 8) {
      newErrors.newPassword = "New Password minimum length should not be less than 8 character!";
    }
    else if (!passwordRegex.test(formData.newPassword)) {
      newErrors.newPassword = "Password must be between 8 to 16 character, including at least 1 upper case, 1 lower case, 1 numeric & 1 sepecial charcter (e.g. @,!,&,#)";
    }
    else if(formData.confirmPassword===""){
      newErrors.confirmPassword = "Please enter your confirmation password!";
      }
    else if (formData.confirmPassword.length < 8) {
        newErrors.confirmPassword = "Confirm Password Minimum length should not be less than 8 character!";
    }
    else if (formData.newPassword !== formData.confirmPassword) {
        newErrors.confirmPassword = "New password and confirmation password do not match!";
    }
    
    
    if (Object.keys(newErrors).length === 0) {
      callChangePasswordApi()
    }
    else{
        setErrors(newErrors);
    }
  };

  function callChangePasswordApi() {
    try {
      if (isNetworkConnectionAvailable) {
        const requestObject = {
          confirmNewPassword: formData.confirmPassword,
          newPassword: formData.newPassword,
          oldPassword: formData.currentPassword,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CHANGE_PASSWORD
        ).then((encryptedContentData) => {

          fetchData(process.env.REACT_APP_CHANGE_PASSWORD_API_URL,ApiType.CHANGE_PASSWORD,ApiType.POST_METHOD, encryptedContentData, {}, (data) => {
            setLoading(false);
            if (data !== null) {
              showSuccessAlert(
                SUCCESS,
                "Password changed successfully."
               );
            }
          });

        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function goToNewPage() {
    navigate(CONSTANT.FINANCE_DASHBOARD);
  }

  function onConfirmButtonResponseReceived(){
    saveToLocalStorage(SESSION_ID,"")
    navigate(CONSTANT.LOGIN);
  }

  return (
    <Box>
    <SnackbarProvider maxSnack={3}>
      <ConnectionStatus />

      <ShowSuccessDialog
          status={getSuccessDialogStatus}
          title={title}
          content={content}
          onConfirmButtonClick={onConfirmButtonResponseReceived}
        />

      <ShowErrorAlertDialog
        status={getDialogStatus}
        title={title}
        content={content}
      />
      {isNetworkConnectionAvailable ? (
        <CustomProgressDialog open={loading} text={getProgressbarText} />
      ) : (
        showNoInternetSnackBar()
      )}

      <Grid
          container
          component="main"
          justifyContent={"center"}
          alignItems={"center"}
          alignContent={"center"}
          height={"100%"}
        >
      
         {/* Header */}
         <Grid container direction={"row"} alignItems={"center"} mb={2} ml={2}>
          <Grid item mr={2}>
            <IconButton onClick={goToNewPage} width={12}>
              <img src={"../../assets/common/Back.svg"} width={12} />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography
              color={colors.grey[100]}
              fontWeight={"600"}
              variant="h3"
            >
              Change Password
            </Typography>
          </Grid>
        </Grid>
        {/* Header */}

        <Container

          sx={{
            background: "#FFF",
            m: "0 2.5%",
            borderRadius : "12px",
            padding: "30px",
          }}

          maxWidth="xs"
        >

        
          
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            
            <Typography pt={1} pb={0.5} sx={{ fontSize:"24px", fontWeight:"bold" }}>
              We're here to Help
            </Typography>

            <Typography pb={2} sx={{ fontSize:"14px", color:"#888" }}>
            Please enter the following to change your password
            </Typography>

            <form>

            <Box>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="currentPassword"
                label="Current Password"
                type={showCurrentPassword ? 'text' : 'password'}

                value={formData.currentPassword}
                onChange={handleInputChange}
                error={Boolean(errors.currentPassword)}
                helperText={errors.currentPassword}

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={toggleCurrentPasswordVisibility} edge="end">
                        {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="newPassword"
                label="New Password"
                type={showNewPassword ? 'text' : 'password'}
                //value={newPassword}
                //onChange={(e) => setNewPassword(e.target.value)}

                value={formData.newPassword}
                onChange={handleInputChange}
                error={Boolean(errors.newPassword)}
                helperText={errors.newPassword}
                inputProps={{ maxLength: 16 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={toggleNewPasswordVisibility} edge="end">
                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="confirmPassword"
                label="Confirm New Password"
                type={showConfirmPassword ? 'text' : 'password'}
              

                value={formData.confirmPassword}
                onChange={handleInputChange}
                error={Boolean(errors.confirmPassword)}
                helperText={errors.confirmPassword}
                inputProps={{ maxLength: 16 }}
                InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={toggleConfirmPasswordVisibility} edge="end">
                          {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
              />
            <Box mt={3} pb={3}>
                      <CustomButton
                          btnBG={colors.primary[100]}
                          btnColor={colors.grey[900]}
                          btnTxt={"CHANGE PASSWORD"}
                          btnBorder={"1px solid" + colors.primary[100]}
                          onClick={handleSubmit}
                        ></CustomButton>
                        </Box>
            </Box>
            </form>
          </Box>
        </Container>

        </Grid>
  
      </SnackbarProvider>
    </Box>
  );
};

export default ChangePassword;
